export const data = {
    nama: 'Nur Arifin',
    nick: 'ipincamp',
    usia: 21,
    jobs: 'Back-End Developer',
    icon: '/assets/img/ipin.png',
    path: 'nur-arifin.my.id',
    about: ["Hello everyone, I am Nur Arifin, 21 years old as a student at Harapan Bangsa University.", "I started to get interested in coding starting in 2019 with an initial project of developing a game server using the Java language.", "until now, I have a little understanding of several other languages such as JavaScript, TypeScript, Python, C, C++, PHP, Java.", "I focus on the Back-End, because from the start I was interested in sharpening logic.", "I have used several databases such as MySQL, MariaDB, MongoDB and SQLite.", "The frameworks I've tried include ExpressJS, ReactJS, NextJS, Flask, Puppeteer.", "Cloud services that I have used include Firebase, Vercel, Netlify, Glitch, Worker, Heroku, OVH Cloud.", "The webserver that I use is Apache and Nginx"],
    sosmed: [
        {
            img: '/assets/img/instagram.png',
            tag: 'Instagram',
            url: 'https://instagram.com/ipincamp'
        },
        {
            img: '/assets/img/twitter.png',
            tag: 'Twitter',
            url: 'https://twitter.com/ipincamp'
        },
        {
            img: '/assets/img/facebook.png',
            tag: 'Facebook',
            url: 'https://www.facebook.com/profile.php?id=100010728341707'
        },
        {
            img: '/assets/img/discord.png',
            tag: 'Discord',
            url: 'https://discord.gg/QR8PHugHvr'
        },
        {
            img: '/assets/img/youtube.png',
            tag: 'YouTube',
            url: 'https://www.youtube.com/channel/UCWyt5GLjfei_mcbOj-9Lvpg'
        },
    ]
}
